import {makeStyles, Typography} from "@material-ui/core";
import React from "react";
import {Grid} from "@material-ui/core";

const useInfoStyles = makeStyles(theme => ({
    root: {
        padding: '2%',
        whiteSpace: 'initial',
        display: 'inline-block',
        width: '100%',
        '& table tr td': {
            border: '1px solid #fff'
        },
        '& a': {
            color: '#fff'
        }
    }
}))
const PagePoliticaCookies = () => {

    const classes = useInfoStyles();

    return <>
        <Grid item xs={12} className={classes.root}>
            <Typography variant="body2" color={"textSecondary"} display={"block"} component="div">
                <div className="sd-section">
                    <div className="page-text">
                        <div className="fusion-text"><h3>Declarație referitoare la cookie-uri</h3>
                            <p>În cadrul Danone, dorim să fim deschiși și transparenți privind modul în care utilizăm
                                cookie-urile și
                                consecințele pe care le pot avea asupra dumneavoastră. Anumite cookie-uri pe care le utilizăm
                                sunt esențiale
                                pentru funcționalitatea paginilor proprii de internet, dar sunt și tipuri de cookie-uri pe care
                                le puteți
                                respinge sau bloca.</p>
                            <p>Ne străduim să vă oferim suficiente informații despre cookie-urile utilizate, pentru ca
                                dumneavoastră să
                                faceți o alegere informată a datelor pe care ni le comunicați.</p>
                            <p>În cazul în care aveți mai multe întrebări sau observații, vă rugăm să ne contactați prin
                                intermediul&nbsp;<a
                                    href="mailto:comunicare@danone.ro">callcenter@mediasat.ro</a>.</p>
                            <p>&nbsp;</p>
                            <h3>Ce sunt cookie-urile?</h3>
                            <p>Cookie este un fișier redus ca volum, salvat în computerul sau dispozitivul dumneavoastră mobil.
                                Acesta are
                                alocat un ID unic, care ajută pagina de internet să rețină acțiunile și preferințele
                                dumneavoastră (precum
                                localizarea, limba, dimensiunea fontului și alte preferințe afișate), într-un anumit interval de
                                timp. În
                                acest fel, nu este necesar să reintroduceți de fiecare dată informațiile la revenirea pe pagina
                                de internet
                                pentru a vizita o secțiune din altă secțiune. În același timp, cookie-urile pot contribui la
                                personalizarea
                                experienței dumneavoastră de navigare.</p>
                            <p>Nu toate cookie-urile conțin informații cu caracter personal, dar, în cazul în care acest lucru
                                se întâmplă,
                                tratăm acest tip de informații ca date cu caracter personal, conform&nbsp;<a
                                    href="http://www.danone.ro/politica-de-confidentialitate/">Declarației privind
                                    confidențialitatea</a>. De asemenea, tratăm informațiile de tip cookie ca date cu caracter
                                personal în
                                cazul în care sunt asociate cu contul dumneavoastră sau alte informații de contact.</p>
                            <p>&nbsp;</p>
                            <h3>Tipuri de cookie-uri</h3>
                            <p>Există două categorii generale de cookie-uri: persistente și per sesiune. Cookie-urile
                                persistente rămân
                                salvate în dispozitivul dumneavoastră până la ștergerea lor manuală sau automată. Cookie-urile
                                per sesiune
                                rămân salvate în dispozitivul dumneavoastră până la închiderea browser-ului, ștergându-se în mod
                                automat.</p>
                            <h3>De ce utilizăm cookie-urile?</h3>
                            <p>În general vorbind, există câteva motive pentru care putem utiliza cookie-urile:</p>
                            <ul>
                                <li>Cookie-uri care sunt strict necesare pentru funcționarea paginii de internet și pentru a
                                    facilita
                                    accesul dumneavoastră la serviciile pe care le oferim;
                                </li>
                                <li>Cookie-urile care colectează date asociate accesării paginii noastre de internet și
                                    performanței
                                    acesteia. Utilizăm aceste informații pentru îmbunătățirea produselor și serviciilor pe care
                                    le oferim
                                    online;
                                </li>
                                <li>Cookie-uri pe care le utilizăm pentru a personaliza și optimiza experiența dumneavoastră pe
                                    pagina
                                    noastră de internet. Aceste cookie-uri stochează informații legate de opțiunile
                                    dumneavoastră, precum
                                    dimensiunea textului, limba și rezoluția afișate.
                                </li>
                                <li>Cookie-uri instalate de terți pentru servicii îmbunătățite (precum cookie-uri platforme
                                    sociale) sau în
                                    scopuri promoționale.
                                </li>
                            </ul>
                            <p>Vă rugăm să consultați informațiile de mai jos referitoare la tipurile de cookie-uri pe care le
                                folosim.</p>
                            <h4>Cookie-uri strict necesare</h4>
                            <p>Acestea sunt cookie-uri de care avem nevoie pentru a vă putea oferi o funcționare corespunzătoare
                                a paginii
                                de internet și care vă facilitează accesul la serviciile pe care le oferim.</p>
                            <p>În cazul în care ele sunt blocate, nu veți mai putea accesa pagina noastră de internet.</p>
                            <p>Listă cookie-uri strict necesare</p>
                            <p>Cookie-urile necesare ajută la creerea unui site web ușor de utilizat, permițând funcții de bază
                                cum ar fi
                                navigarea pe pagini și accesul în zonele securizate ale site-ului web. Site-ul web nu poate
                                funcționa corect
                                fără aceste cookie-uri.</p>
                            <table className="table-1" width="100%">
                                <tbody>
                                <tr>
                                    <td width="26%"><strong>Scop</strong></td>
                                    <td width="25%"><strong>Tip de date colectate</strong></td>
                                    <td width="22%"><strong>Cât timp rămâne stocată?</strong></td>
                                </tr>
                                <tr>
                                    <td width="26%">Salvează limba preferată a utilizatorului pe site.</td>
                                    <td width="25%">&nbsp;<p></p>
                                        <p>Varianta de limba utilizata</p></td>
                                    <td width="22%">&nbsp;<p></p>
                                        <p>Pe sesiune</p></td>
                                </tr>
                                </tbody>
                            </table>
                            <p>&nbsp;</p>
                            <h4>Cookie-uri analitice și de performanță</h4>
                            <p>Acestea ne ajută să măsurăm modelele de trafic pentru a stabili secțiunile vizitate din pagina
                                noastră de
                                internet. Le utilizăm pentru studia tiparurile vizitatorului, astfel încât să putem îmbunătăți
                                produsele și
                                serviciile pe care le oferim în mediul online. Putem stoca adresele IP (adrese electronice ale
                                computerelor
                                conectate la internet) pentru a analiza tendințele, administra pagina de internet, monitoriza
                                mișcările
                                utilizatorului și colecta informații generale demografice.</p>
                            <p>Aceste cookie-uri nu sunt esențiale pentru funcționalitatea paginii de internet, în consecință vă
                                solicităm
                                întotdeauna consimțământul înainte de instalarea lor.&nbsp; Acordul dumneavoastră va fi valabil
                                până la 13
                                luni. Aveți mai multe informații&nbsp;<a href="http://www.danone.ro/politica-cookies/">aici</a>.
                            </p>
                            <p>&nbsp;</p>
                            <h4>Listă cookie-uri de performanță</h4>
                            <table className="table-1" width="100%">
                                <tbody>
                                <tr>
                                    <td width="26%"><strong>Scop</strong></td>
                                    <td width="25%"><strong>Tip de date colectate</strong></td>
                                    <td width="25%"><strong>Denumire cookie</strong></td>
                                    <td width="22%"><strong>Cât timp rămâne stocată?</strong></td>
                                </tr>
                                <tr>
                                    <td width="26%">&nbsp;<p></p>
                                        <p>Înregistrează un ID unic care este utilizat pentru a genera date statistice despre
                                            modul în care
                                            vizitatorul folosește site-ul web.</p></td>
                                    <td width="25%">&nbsp;<p></p>
                                        <p>Intervalul petrecut pe pagina de internet, pagini de referință, istoric navigare,
                                            tipul de
                                            browser, sistemul de operare, rezoluţia, tipul de device.</p></td>
                                    <td width="25%">&nbsp;<p></p>
                                        <p>_ga</p>
                                        <p>Google Analytics</p></td>
                                    <td width="22%">&nbsp;<p></p>
                                        <p>2 ani</p></td>
                                </tr>
                                <tr>
                                    <td width="26%">&nbsp;<p></p>
                                        <p>Utilizat de Google Analytics pentru a reduce rata solicitărilor.</p></td>
                                    <td width="25%"></td>
                                    <td width="25%">&nbsp;<p></p>
                                        <p>_gat</p>
                                        <p>Google Analytics</p></td>
                                    <td width="22%">&nbsp;<p></p>
                                        <p>Pe sesiune</p></td>
                                </tr>
                                <tr>
                                    <td width="26%">&nbsp;<p></p>
                                        <p>Înregistrează un ID unic care este utilizat pentru a genera date statistice despre
                                            modul în care
                                            vizitatorul folosește site-ul web.</p>
                                        <p>&nbsp;</p></td>
                                    <td width="25%"></td>
                                    <td width="25%">&nbsp;<p></p>
                                        <p>_gid</p></td>
                                    <td width="22%">&nbsp;<p></p>
                                        <p>Pe sesiune</p></td>
                                </tr>
                                <tr>
                                    <td width="26%">&nbsp;<p></p>
                                        <p>&nbsp;</p>
                                        <p>–</p>
                                        <p>&nbsp;</p>
                                        <p>&nbsp;</p></td>
                                    <td width="25%">&nbsp;<p></p>
                                        <p>&nbsp;</p>
                                        <p>–</p></td>
                                    <td width="25%">&nbsp;<p></p>
                                        <p>current_source</p>
                                        <p>cremosso.ro</p></td>
                                    <td width="22%">&nbsp;<p></p>
                                        <p>Pe sesiune</p></td>
                                </tr>
                                <tr>
                                    <td width="26%"></td>
                                    <td width="25%"></td>
                                    <td width="25%">&nbsp;<p></p>
                                        <p>localidtag1</p>
                                        <p>cremosso.ro</p></td>
                                    <td width="22%">&nbsp;<p></p>
                                        <p>1 an</p></td>
                                </tr>
                                <tr>
                                    <td width="26%"></td>
                                    <td width="25%"></td>
                                    <td width="25%">&nbsp;<p></p>
                                        <p>Research</p>
                                        <p>cremosso.ro</p></td>
                                    <td width="22%">&nbsp;<p></p>
                                        <p>6 zile</p></td>
                                </tr>
                                <tr>
                                    <td width="26%"></td>
                                    <td width="25%"></td>
                                    <td width="25%">&nbsp;<p></p>
                                        <p>Synced</p>
                                        <p>cremosso.ro</p></td>
                                    <td width="22%">&nbsp;<p></p>
                                        <p>2 zile</p></td>
                                </tr>
                                </tbody>
                            </table>
                            <p>&nbsp;</p>
                            <h4>Cookie-uri terți</h4>
                            <p>Acestea sunt instalate pe pagina noastră de internet de către terți, în numele nostru. Ele ne
                                ajută să
                                generăm mesaje promoționale personalizate pe alte pagini de internet, în baza informațiilor care
                                vă aparțin,
                                precum numărul de vizite pe pagina proprie. Paginile noastre de internet pot instala cookie-uri
                                și pentru
                                servicii terțe, precum platformele sociale: Dacă apăsați ”Distribuire pe Facebook” poate însemna
                                instalarea
                                de cookie Facebook în browser-ul personal.</p>
                            <p>Nu oferim terților informații cu caracter personal care instalează cookie-uri pe pagina noastră
                                de internet.
                                Cu toate acestea, terții pot presupune că utilizatorii care interacționează sau care accesează
                                reclame
                                personalizate sau conținut afișat pe pagina noastră de internet se încadrează într-un grup vizat
                                de mesajele
                                sau conținutul respectiv. Nu avem acces și nu controlăm cookie-urile sau alte proprietăți pe
                                care le pot
                                utiliza paginile de internet care aparțin agențiilor de publicitate și terților. Practicile
                                informaționale
                                ale acestor terți nu sunt acoperite de Declarația privind confidențialitatea sau referitoare la
                                cookie.
                                Pentru mai multe informații despre practicile terților privind confidențialitatea, vă rugăm să-i
                                contactați
                                în mod direct.</p>
                            <p>Aceste cookie-uri nu sunt esențiale pentru funcționalitatea paginii de internet, în consecință vă
                                solicităm
                                întotdeauna consimțământul înainte de instalarea lor.&nbsp; Acordul dumneavoastră va fi valabil
                                până la 13
                                luni.&nbsp; Aveți mai multe informații&nbsp;<a
                                    href="https://www.danone.ro/politica-cookies/">aici</a>.</p>
                            <h4>Marketing cookies</h4>
                            <p>Cookie-urile de marketing sunt folosite pentru a urmări vizitatorii pe site-uri web. Intenția
                                este de a afișa
                                anunțuri relevante și angajate pentru utilizatorul individual și, prin urmare, mai valoroase
                                pentru editori
                                și pentru agenții de publicitate terță parte.</p>
                            <p>&nbsp;</p>
                            <p>&nbsp;</p>
                            <p>&nbsp;</p>
                            <h4>Listă cookie-uri terți si marketing</h4>
                            <table className="table-1" width="100%">
                                <tbody>
                                <tr>
                                    <td width="29%"><strong>Scop</strong></td>
                                    <td width="17%"><strong>Tip de date colectate</strong></td>
                                    <td width="33%"><strong>Denumire cookie</strong></td>
                                    <td width="19%"><strong>Cât timp rămâne stocată?</strong></td>
                                </tr>
                                <tr>
                                    <td width="29%">&nbsp;<p></p>
                                        <p>Permite afişarea de conţinut personalizat în scop de marketing.</p>
                                        <p>&nbsp;</p></td>
                                    <td width="17%"></td>
                                    <td width="33%">&nbsp;<p></p>
                                        <p>0</p>
                                        <p>Adform</p></td>
                                    <td width="19%">&nbsp;<p></p>
                                        <p>Pe sesiune</p></td>
                                </tr>
                                <tr>
                                    <td width="29%">&nbsp;<p></p>
                                        <p>Permite afişarea de conţinut personalizat în scop de marketing.</p></td>
                                    <td width="17%"></td>
                                    <td width="33%">&nbsp;<p></p>
                                        <p>296418110</p>
                                        <p>296418112</p>
                                        <p>296418129</p>
                                        <p>356329310</p>
                                        <p>356329312</p>
                                        <p>356329313</p>
                                        <p>356329314</p>
                                        <p>356329329</p>
                                        <p>Chargeads.com</p></td>
                                    <td width="19%">&nbsp;<p></p>
                                        <p>Pe sesiune</p></td>
                                </tr>
                                <tr>
                                    <td width="29%">&nbsp;<p></p>
                                        <p>Reglează sincronizarea identificării utilizatorilor și schimbul de date utilizat
                                            între diferite
                                            servicii de publicitate.</p></td>
                                    <td width="17%"></td>
                                    <td width="33%">&nbsp;<p></p>
                                        <p>C</p>
                                        <p>bidswitch.net</p></td>
                                    <td width="19%">&nbsp;<p></p>
                                        <p>1 an</p></td>
                                </tr>
                                <tr>
                                    <td width="29%">&nbsp;<p></p>
                                        <p>Permite afişarea de conţinut personalizat în scop de marketing.</p>
                                        <p>&nbsp;</p></td>
                                    <td width="17%"></td>
                                    <td width="33%">&nbsp;<p></p>
                                        <p>cid</p>
                                        <p>adform.net</p></td>
                                    <td width="19%">&nbsp;<p></p>
                                        <p>2 luni</p></td>
                                </tr>
                                <tr>
                                    <td width="29%">&nbsp;<p></p>
                                        <p>Permite afişarea de conţinut personalizat în scop de marketing.</p></td>
                                    <td width="17%"></td>
                                    <td width="33%">&nbsp;<p></p>
                                        <p>Cm</p>
                                        <p>chargeads.com</p></td>
                                    <td width="19%">&nbsp;<p></p>
                                        <p>2 ani</p></td>
                                </tr>
                                <tr>
                                    <td width="29%"></td>
                                    <td width="17%"></td>
                                    <td width="33%">&nbsp;<p></p>
                                        <p>demconf.jpg</p>
                                        <p>demdex.net</p></td>
                                    <td width="19%">&nbsp;<p></p>
                                        <p>Sesiune</p></td>
                                </tr>
                                <tr>
                                    <td width="29%">&nbsp;<p></p>
                                        <p>Printr-un ID unic care este utilizat pentru analiza conținutului semantic, navigarea
                                            utilizatorului de pe site este înregistrată și legată de date offline din sondaje și
                                            înregistrări similare pentru a afișa anunțuri direcționate.</p>
                                        <p>&nbsp;</p>
                                        <p>&nbsp;</p></td>
                                    <td width="17%"></td>
                                    <td width="33%">&nbsp;<p></p>
                                        <p>Demdex</p>
                                        <p>demdex.net</p></td>
                                    <td width="19%">&nbsp;<p></p>
                                        <p>179 zile</p></td>
                                </tr>
                                <tr>
                                    <td width="29%"></td>
                                    <td width="17%"></td>
                                    <td width="33%">&nbsp;<p></p>
                                        <p>Dpm</p>
                                        <p>demdex.net</p>
                                        <p>&nbsp;</p></td>
                                    <td width="19%">&nbsp;<p></p>
                                        <p>179 zile</p></td>
                                </tr>
                                <tr>
                                    <td width="29%">&nbsp;<p></p>
                                        <p>Înregistrează un ID unic pe dispozitivele mobile pentru a permite urmărirea pe baza
                                            locației GPS
                                            geografice.</p>
                                        <p>&nbsp;</p></td>
                                    <td width="17%"></td>
                                    <td width="33%">&nbsp;<p></p>
                                        <p>GPS</p>
                                        <p>youtube.com</p></td>
                                    <td width="19%">&nbsp;<p></p>
                                        <p>Pe sesiune</p></td>
                                </tr>
                                <tr>
                                    <td width="29%">&nbsp;<p></p>
                                        <p>Înregistrează un ID unic care identifică dispozitivul utilizatorului. ID-ul este
                                            utilizat pentru
                                            anunțurile direcționate.</p>
                                        <p>&nbsp;</p>
                                        <p>&nbsp;</p></td>
                                    <td width="17%"></td>
                                    <td width="33%">&nbsp;<p></p>
                                        <p>Id</p>
                                        <p>mookie1.com</p></td>
                                    <td width="19%">&nbsp;<p></p>
                                        <p>1 an</p></td>
                                </tr>
                                <tr>
                                    <td width="29%">&nbsp;<p></p>
                                        <p>Folosit de Google DoubleClick pentru a înregistra și a raporta acțiunile
                                            utilizatorului site-ului
                                            după ce a văzut sau a făcut clic pe unul dintre anunțurile agentului de publicitate,
                                            în scopul
                                            de a măsura eficacitatea unui anunț și de a prezenta anunțuri direcționate
                                            utilizatorului.</p>
                                        <p>&nbsp;</p></td>
                                    <td width="17%"></td>
                                    <td width="33%">&nbsp;<p></p>
                                        <p>IDE</p>
                                        <p>doubleclick.net</p></td>
                                    <td width="19%">&nbsp;<p></p>
                                        <p>1 an</p></td>
                                </tr>
                                <tr>
                                    <td width="29%">&nbsp;<p></p>
                                        <p>Înregistrează un ID unic care identifică dispozitivul utilizatorului. ID-ul este
                                            utilizat pentru
                                            anunțurile direcționate.</p>
                                        <p>&nbsp;</p></td>
                                    <td width="17%"></td>
                                    <td width="33%">&nbsp;<p></p>
                                        <p>Mdata</p>
                                        <p>mookie1.com</p></td>
                                    <td width="19%">&nbsp;<p></p>
                                        <p>1 an</p></td>
                                </tr>
                                <tr>
                                    <td width="29%">&nbsp;<p></p>
                                        <p>Înregistrează un ID unic care identifică dispozitivul utilizatorului. ID-ul este
                                            utilizat pentru
                                            anunțurile direcționate.</p>
                                        <p>&nbsp;</p>
                                        <p>&nbsp;</p></td>
                                    <td width="17%"></td>
                                    <td width="33%">&nbsp;<p></p>
                                        <p>NID</p>
                                        <p>google.com</p></td>
                                    <td width="19%">&nbsp;<p></p>
                                        <p>6 luni</p></td>
                                </tr>
                                <tr>
                                    <td width="29%">&nbsp;<p></p>
                                        <p>Înregistrează un cod unic folosit de Google pentru a păstra statistici despre modul
                                            în care
                                            vizitatorul folosește videoclipuri YouTube pe site-uri diferite.</p>
                                        <p>&nbsp;</p>
                                        <p>&nbsp;</p></td>
                                    <td width="17%"></td>
                                    <td width="33%">&nbsp;<p></p>
                                        <p>PREF</p>
                                        <p>youtube.com</p></td>
                                    <td width="19%">&nbsp;<p></p>
                                        <p>8 luni</p></td>
                                </tr>
                                <tr>
                                    <td width="29%"></td>
                                    <td width="17%"></td>
                                    <td width="33%">&nbsp;<p></p>
                                        <p>r/collect</p>
                                        <p>doubleclick.net</p></td>
                                    <td width="19%">&nbsp;<p></p>
                                        <p>Pe sesiune</p></td>
                                </tr>
                                <tr>
                                    <td width="29%"></td>
                                    <td width="17%"></td>
                                    <td width="33%">&nbsp;<p></p>
                                        <p>t/v2/activity</p>
                                        <p>mookie1.com</p></td>
                                    <td width="19%">&nbsp;<p></p>
                                        <p>Pe sesiune</p></td>
                                </tr>
                                <tr>
                                    <td width="29%">&nbsp;<p></p>
                                        <p>Se utilizează pentru a verifica dacă browserul utilizatorului acceptă cookie-uri.</p>
                                    </td>
                                    <td width="17%"></td>
                                    <td width="33%">&nbsp;<p></p>
                                        <p>test_cookie</p>
                                        <p>doubleclick.net</p></td>
                                    <td width="19%">&nbsp;<p></p>
                                        <p>Pe sesiune</p></td>
                                </tr>
                                <tr>
                                    <td width="29%">&nbsp;<p></p>
                                        <p>Înregistrează dacă utilizatorul a consimțit sau nu să utilizeze cookie-uri.</p>
                                        <p>&nbsp;</p>
                                        <p>&nbsp;</p></td>
                                    <td width="17%"></td>
                                    <td width="33%">&nbsp;<p></p>
                                        <p>tuuid</p>
                                        <p>bidswitch.net</p></td>
                                    <td width="19%">&nbsp;<p></p>
                                        <p>1 an</p></td>
                                </tr>
                                <tr>
                                    <td width="29%"></td>
                                    <td width="17%"></td>
                                    <td width="33%">&nbsp;<p></p>
                                        <p>tuuid</p>
                                        <p>tuuid_last_update</p>
                                        <p>chargeads.com</p>
                                        <p>&nbsp;</p></td>
                                    <td width="19%">&nbsp;<p></p>
                                        <p>2 ani</p></td>
                                </tr>
                                <tr>
                                    <td width="29%"></td>
                                    <td width="17%"></td>
                                    <td width="33%">&nbsp;<p></p>
                                        <p>tuuid_lu</p>
                                        <p>bidswitch.net</p></td>
                                    <td width="19%">&nbsp;<p></p>
                                        <p>1 an</p></td>
                                </tr>
                                <tr>
                                    <td width="29%"></td>
                                    <td width="17%"></td>
                                    <td width="33%">&nbsp;<p></p>
                                        <p>Ug</p>
                                        <p>chargeads.com</p></td>
                                    <td width="19%">&nbsp;<p></p>
                                        <p>2 ani</p></td>
                                </tr>
                                <tr>
                                    <td width="29%">&nbsp;<p></p>
                                        <p>Înregistrează un cod de utilizator unic care recunoaște browserul utilizatorului când
                                            vizitează
                                            site-uri care utilizează aceeași rețea publicitară. Scopul este de a optimiza
                                            afișarea
                                            anunțurilor în funcție de mișcările utilizatorului și de sumele licitate ale
                                            diferiților
                                            furnizori de anunțuri pentru afișarea unui utilizator ds.</p>
                                        <p>&nbsp;</p></td>
                                    <td width="17%"></td>
                                    <td width="33%">&nbsp;<p></p>
                                        <p>Uid</p>
                                        <p>adform.net</p>
                                        <p>&nbsp;</p></td>
                                    <td width="19%">&nbsp;<p></p>
                                        <p>2 luni</p></td>
                                </tr>
                                <tr>
                                    <td width="29%"></td>
                                    <td width="17%"></td>
                                    <td width="33%">&nbsp;<p></p>
                                        <p>ul_cb/sync</p>
                                        <p>bidswitch.net</p></td>
                                    <td width="19%">&nbsp;<p></p>
                                        <p>Pe sesiune</p></td>
                                </tr>
                                <tr>
                                    <td width="29%">&nbsp;<p></p>
                                        <p>Înregistrează un cod unic pentru a păstra statisticile despre ce videoclipuri YouTube
                                            au văzut
                                            utilizatorii.</p></td>
                                    <td width="17%"></td>
                                    <td width="33%">&nbsp;<p></p>
                                        <p>YSC</p>
                                        <p>youtube.com</p></td>
                                    <td width="19%">&nbsp;<p></p>
                                        <p>Pe sesiune</p></td>
                                </tr>
                                </tbody>
                            </table>
                            <p>&nbsp;</p>
                            <h3>Preferințe personale</h3>
                            <p>Aveți posibilitatea de a restricționa sau bloca cookie-urile, sau chiar de a le șterge pe cele
                                deja instalate
                                în dispozitivul personal. În acest caz, este posibil să nu mai puteți accesa anumite secțiuni
                                din pagina de
                                internet, mesajul primit de noi fiind acela că nu ne-ați vizitat niciodată înainte, situația în
                                care se va
                                afișa iar Notificarea referitoare la cookie, solicitându-vă consimțământul pentru instalarea
                                lor.</p>
                            <p>Pagina noastră de internet vă oferă un instrument de administrare cookie-uri. &nbsp;Acest
                                instrument se poate
                                accesa&nbsp;<a href="https://www.danone.ro/politica-cookies/">aici</a>.</p>
                            <p>Configurația fiecărui browser este diferită. Este descrisă în meniul de ajutor al browserului
                                dumneavoastră,
                                care vă permite să știți cum să vă schimbați preferințele pentru cookie-uri.</p>
                            <ul>
                                <li><a
                                    href="https://support.mozilla.org/ro/kb/sterge-cookies-pentru-elimina-informaiile-stocate-computer">https://support.mozilla.org/ro/kb/sterge-cookies-pentru-elimina-informaiile-stocate-computer</a>
                                </li>
                                <li>
                                    <a href="https://support.microsoft.com/ro-ro/help/278835/how-to-delete-cookie-files-in-internet-explorer">https://support.microsoft.com/ro-ro/help/278835/how-to-delete-cookie-files-in-internet-explorer</a>
                                </li>
                                <li><a
                                    href="https://support.google.com/chrome/answer/95647?hl=ro">https://support.google.com/chrome/answer/95647?hl=ro</a>
                                </li>
                                <li><a
                                    href="https://support.apple.com/ro-ro/guide/safari/sfri11471/mac">https://support.apple.com/ro-ro/guide/safari/sfri11471/mac</a>
                                </li>
                                <li><a
                                    href="https://help.opera.com/en/presto/browser-behavior/">https://help.opera.com/en/presto/browser-behavior/</a>
                                </li>
                            </ul>
                            <p>&nbsp;</p>
                            <h3>Informații de contact</h3>
                            <p>În cazul în care aveți întrebări, observații sau reclamații cu privire la cookie-uri, vă rugăm să
                                ne
                                contactați prin intermediul adresei de email&nbsp;<a
                                    href="mailto:comunicare@danone.ro">callcenter@mediasat.ro</a>.
                            </p>
                            <p>&nbsp;</p>
                        </div>


                        <div className="bottom-content">

                        </div>

                    </div>
                </div>
            </Typography>
        </Grid>
    </>


}

export default PagePoliticaCookies;
